<template>
  <a-dropdown>
    <span class="action">
      <a-icon
        type="global"
      />
    </span>
    <a-menu slot="overlay" @click="switchLang">
      <a-menu-item v-for="(item, index) in langLibrary" :key="index">
        <a rel="noopener noreferrer">
          <span role="img" :aria-label="item.displayName"></span> {{item.displayName}}
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mixin as langMixin } from '@/locales/i18n-mixin'
import { mapGetters } from 'vuex'

export default {
  name: 'LangSelect',
  mixins: [langMixin],
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['i18n', 'langLibrary'])
  },
  methods: {
    switchLang(row) {
      this.setLang(this.langLibrary[row.key].name)
    }
  }
}
</script>

<style lang="less" scoped>

</style>
